import Axios from "axios";
import { json } from "body-parser";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useAppContext } from "../../context/state";
import { storage, useRequest } from "../../utils";
var FormData = require("form-data");
var axios = require("axios");
var FormData = require("form-data");
// import "../../assets/css/plugins/forms/wizard.css";
import ScriptTag from "react-script-tag";

import utils from "../../components/toastify/toastify";

const EditTerm = (props) => {
  const myTerm = props.location.query.item;
  const [title, setTitle] = useState(myTerm.title);
  const [description, setDescription] = useState(myTerm.description);
  const [price, setPrice] = useState(myTerm.price);
  const [support_price, setSupport_price] = useState(myTerm.support_price);

  const [
    edit_term_error,
    edit_term_loading,
    edit_term_data,
    edit_term_function,
  ] = useRequest({
    method: "post",
    url: "/edit_term",
    body: {
      product_id: props.match.params.product_id,
      term_id: props.match.params.term_id,
      title,
      description,
      price,
      support_price,
    },
  });

  let history = useHistory();

  const sendData = () => {
    var formData = new FormData();

    var $white = "#fff";
    $.blockUI({
      message:
        '<div class="semibold"><span class="bx bx-reset icon-spin text-left align-middle" style="padding-bottom:1.75px"></span>&nbsp; در حال انجام عملیات ...</div>',

      // timeout: 2000, //unblock after 2 seconds
      overlayCSS: {
        backgroundColor: $white,
        opacity: 0.8,
        cursor: "wait",
      },
      css: {
        border: 0,
        padding: 0,
        backgroundColor: "transparent",
      },
    });

    edit_term_function()
      .then((res) => {
        utils.showAlert("ترم با موفقیت بروزرسانی شد.", "success");
        history.push("/dashboard/terms/" + props.match.params.product_id);

        $.unblockUI();
      })
      .catch((err) => {
        utils.showAlert("خطایی به وجود آمده است", "error");
        $.unblockUI();
      });
  };

  return (
    <div className="AddProductContainer">
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">مسیر</h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active">ویرایش ترم جدید</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Wizard /> */}
      {/* <!-- Basic Inputs start --> */}
      <section id="basic-input">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">ویرایش ترم جدید</h4>
              </div>

              <div class="card">
                {/* <div class="card-header">
                <h4 class="card-title">ترم ها</h4>
              </div> */}
                <div class="card-content">
                  <div class="card-body">
                    <form action="#" class="contact-repeater">
                      <div data-repeater-list="contact">
                        <div
                          class="row justify-content-between"
                          data-repeater-item
                        >
                          <div class="col-md-6 col-12 form-group d-flex align-items-center">
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  marginBottom: "10px",
                                }}
                              >
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="عنوان ترم"
                                  value={title}
                                  onChange={(e) => setTitle(e.target.value)}
                                />
                              </div>
                              <input
                                type="text"
                                style={{
                                  marginBottom: "10px",
                                }}
                                class="form-control"
                                placeholder="توضیح یک خطی ترم"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                              />
                              <input
                                type="number"
                                style={{
                                  marginBottom: "10px",
                                }}
                                class="form-control"
                                placeholder="مبلغ ترم"
                                value={price}
                                onChange={(e) => setPrice(e.target.value)}
                              />
                              <input
                                type="number"
                                class="form-control"
                                placeholder="مبلغ پشتیبانی"
                                value={support_price}
                                onChange={(e) =>
                                  setSupport_price(e.target.value)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <button
                onClick={() => {
                  sendData();
                }}
                style={{
                  marginTop: "-2rem",
                  marginRight: "25px",
                  width: "fit-content",
                }}
                type="button"
                class="btn btn-success mr-1 mb-1 "
              >
                ویرایش ترم
              </button>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Basic Inputs end --> */}
      {/* <Demo /> */}
    </div>
  );
};

export { EditTerm };
